import React, { useState, forwardRef } from 'react';
import styled from 'styled-components';
const Fallback = styled.div `
  width: 100%;
  height: 100%;
  background-color: #ccc;
`;
const supportedDensity = ['1x', '2x'];
/**
 * @param url image url in pattern `${path}/${name}-${size}-${density}.webp`(e.g.: '../../../src/name-medium-1x.webp')
 * returns fallback src for img tags
 */
function getSrcList(url) {
    const path = url.substr(0, url.lastIndexOf('.')).substr(0, url.lastIndexOf('-'));
    const src = `${path}.jpg`;
    const set = supportedDensity.map((dpi) => `${path}-${dpi}.jpg ${dpi}`).join(', ');
    return { src, set };
}
const Picture = forwardRef(function Picture({ alt = 'tumbnail', src = '', className, styles, ...rest }, ref) {
    const [isLoaded, setLoaded] = useState(false);
    if (!src) {
        return React.createElement("img", { alt: "no media", src: "./fallback.jpg" });
    }
    const srcList = getSrcList(src);
    function onLoadHandler() {
        setLoaded(true);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("picture", { className: className, style: isLoaded ? { ...styles } : { ...styles, display: 'none' } },
            React.createElement("source", { type: "image/webp", srcSet: src }),
            React.createElement("source", { srcSet: src }),
            React.createElement("img", { alt: alt, src: srcList.src, srcSet: srcList.set, onLoad: onLoadHandler, ref: ref, ...rest })),
        React.createElement(Fallback, { style: !isLoaded ? {} : { display: 'none' } })));
});
export default Picture;
